function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "preferred-browser-off_svg__linear-gradient",
  x1: 73.87,
  x2: 506.89,
  y1: 282.59,
  y2: 282.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fee6ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bf8ce0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#preferred-browser-off_svg__linear-gradient",
  id: "preferred-browser-off_svg__linear-gradient-2",
  x1: 290.38,
  x2: 290.38,
  y1: 538.72,
  y2: 26.45
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "preferred-browser-off_svg__linear-gradient-3",
  x1: 140.7,
  x2: 391.01,
  y1: 338.98,
  y2: 248,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#371447"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#491c5d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#592472"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5f2779"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "preferred-browser-off_svg__linear-gradient-4",
  x2: 147.75,
  y1: 426.79,
  y2: 426.79,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#ffb7d1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cb3974"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "preferred-browser-off_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.22 157.59v250l216.5 125 216.51-125v-250l-216.51-125-216.5 125z",
  fill: "none"
})), /*#__PURE__*/React.createElement("style", null, ".preferred-browser-off_svg__cls-15,.preferred-browser-off_svg__cls-8,.preferred-browser-off_svg__cls-9{stroke-miterlimit:10}.preferred-browser-off_svg__cls-8,.preferred-browser-off_svg__cls-9{fill:#22d6b7}.preferred-browser-off_svg__cls-8{stroke:#e9cfff}.preferred-browser-off_svg__cls-15,.preferred-browser-off_svg__cls-8,.preferred-browser-off_svg__cls-9{stroke-width:9.28px}.preferred-browser-off_svg__cls-15,.preferred-browser-off_svg__cls-9{stroke:#cca1e5}.preferred-browser-off_svg__cls-13{fill:#fff}.preferred-browser-off_svg__cls-15{fill:#ff92ba}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "preferred-browser-off_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "preferred-browser-off_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.88 157.59v250l216.5 125 216.51-125v-250l-216.51-125-216.5 125z",
  fill: "url(#preferred-browser-off_svg__linear-gradient)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#preferred-browser-off_svg__clip-path)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M157.96 38.79v504.16m47.09-504.16v504.16M63.77 38.79v504.16m47.09-504.16v504.16M346.33 38.79v504.16m47.09-504.16v504.16M252.14 38.79v504.16m47.09-504.16v504.16M487.6 38.79v504.16m47.09-504.16v504.16M440.51 38.79v504.16m110.81-393.36H47.15m504.17 47.1H47.15M551.32 55.41H47.15m504.17 47.09H47.15m504.17 235.46H47.15m504.17 47.1H47.15m504.17-141.28H47.15m504.17 47.09H47.15m504.17 188.37H47.15m504.17 47.09H47.15m504.17-94.18H47.15",
  strokeMiterlimit: 10,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.34
})), /*#__PURE__*/React.createElement("rect", {
  width: 45.88,
  height: 45.88,
  x: 188.08,
  y: 265.95,
  className: "preferred-browser-off_svg__cls-8",
  rx: 22.94
}), /*#__PURE__*/React.createElement("rect", {
  width: 45.88,
  height: 45.88,
  x: 337.82,
  y: 345.18,
  className: "preferred-browser-off_svg__cls-9",
  rx: 22.94
}), /*#__PURE__*/React.createElement("rect", {
  width: 45.88,
  height: 45.88,
  x: 336.63,
  y: 179.89,
  className: "preferred-browser-off_svg__cls-9",
  rx: 22.94
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.87 175.85v213.47a31.63 31.63 0 0015.82 27.4l184.87 106.74a31.65 31.65 0 0031.64 0l184.87-106.74a31.63 31.63 0 0015.82-27.4V175.85a31.62 31.62 0 00-15.82-27.39L306.2 41.72a31.65 31.65 0 00-31.64 0L89.69 148.46a31.62 31.62 0 00-15.82 27.39z",
  strokeWidth: 22.06,
  stroke: "url(#preferred-browser-off_svg__linear-gradient-2)",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.45 346.1a272.85 272.85 0 01-41.78 13.55c1.61-8.15 3.12-17 4.39-26.62 1.4-10.6 2.54-22.5 3.11-35.39 16.91-1.41 33.49-3.47 49.2-6.36a132.24 132.24 0 01-14.92 54.82zm-251.09-55.23c9 1.12 26.82 3.18 50.06 5.09a357.35 357.35 0 006.88 64.2 330.26 330.26 0 01-40.19-10.72 132.23 132.23 0 01-16.75-58.57zm16.87-71.38c4.39-1.86 18.09-7.12 41.26-11.27-1.71 8.5-3.31 17.83-4.64 27.89a406 406 0 00-3.48 48.83c-23.86-2-41.89-4.15-50.06-5.19a132.28 132.28 0 0116.92-60.26zM423.46 280a489 489 0 01-48.95 6.52 363.75 363.75 0 00-6.88-77.49q17.39 2.53 36.46 6.27a132.34 132.34 0 0119.37 64.7zm-60 7.38c-22.93 1.58-46 2-67.57 1.8v-86.35a584.83 584.83 0 0160.11 4.66 351.06 351.06 0 017.46 79.93zm-67.57-95.75v-40.1a132.32 132.32 0 0146.66 10.53 298.8 298.8 0 0110.8 33.94c-21-2.58-40.14-3.91-57.46-4.33zm-11-.15a422.84 422.84 0 00-55.07 3.24 326.14 326.14 0 019.81-33.29 132.29 132.29 0 0145.26-9.94zm-55 14.47a415.31 415.31 0 0155-3.31v86.37c-13.09-.26-25.49-.75-36.76-1.34-10.46-.54-20.43-1.2-29.7-1.89a392.78 392.78 0 013.34-47.93c1.52-11.5 3.41-22.09 5.41-31.52zm-11.38 90.83c19.64 1.45 42.34 2.7 66.39 3.2v68.1a379.02 379.02 0 01-36.83-2.5c-7.79-.92-15.14-2-22-3.23a344.33 344.33 0 01-7.6-65.53zm27.95 79.71a384.21 384.21 0 0038.44 2.62v38.47a132.48 132.48 0 01-45.29-10 298.55 298.55 0 01-10.79-33.6c5.55 1.02 11.44 1.82 17.6 2.55zm49.47 2.64a340.79 340.79 0 0056.34-5.24 331.88 331.88 0 01-9.72 33.18 132.57 132.57 0 01-46.62 10.51zm0-11v-68q5.48.06 11 .06c18.51 0 37.48-.51 56.2-1.77-.57 11.9-1.63 22.92-2.93 32.78a410.829 410.829 0 01-5.29 31 327.78 327.78 0 01-59.02 5.95zm99.2-165.75q-15.55-2.85-30-4.87c-2.24-9.35-4.95-18.8-8.19-28.28a134.06 134.06 0 0138.15 33.17zm-169.46-34.16c-2.2 7-4.95 16.54-7.65 28.25a259 259 0 00-33.72 7.69 134.14 134.14 0 0141.37-35.94zM183.55 364c8.26 2.39 19.62 5.31 33.35 8 2.29 9.5 5 19.11 8.37 28.76A134.26 134.26 0 01183.55 364zm172.93 36.15c2.23-7.12 5-16.82 7.67-28.6A292.11 292.11 0 00399 361.6a134.2 134.2 0 01-42.52 38.54z",
  fill: "url(#preferred-browser-off_svg__linear-gradient-3)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73.87,
  cy: 426.79,
  r: 73.87,
  fill: "url(#preferred-browser-off_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 19.91,
  height: 57.3,
  x: 63.92,
  y: 382.21,
  className: "preferred-browser-off_svg__cls-13",
  rx: 9.95
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73.87,
  cy: 460.96,
  r: 10.4,
  className: "preferred-browser-off_svg__cls-13"
}), /*#__PURE__*/React.createElement("rect", {
  width: 45.88,
  height: 45.88,
  x: 188.08,
  y: 265.95,
  className: "preferred-browser-off_svg__cls-8",
  rx: 22.94
}), /*#__PURE__*/React.createElement("rect", {
  width: 45.88,
  height: 45.88,
  x: 337.82,
  y: 345.18,
  className: "preferred-browser-off_svg__cls-9",
  rx: 22.94
}), /*#__PURE__*/React.createElement("rect", {
  width: 45.88,
  height: 45.88,
  x: 336.63,
  y: 179.89,
  className: "preferred-browser-off_svg__cls-9",
  rx: 22.94
}), /*#__PURE__*/React.createElement("rect", {
  width: 45.88,
  height: 45.88,
  x: 188.08,
  y: 265.95,
  rx: 22.94,
  fill: "#ff92ba",
  strokeWidth: 9.28,
  stroke: "#e9cfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("rect", {
  width: 45.88,
  height: 45.88,
  x: 337.82,
  y: 345.18,
  className: "preferred-browser-off_svg__cls-15",
  rx: 22.94
}), /*#__PURE__*/React.createElement("rect", {
  width: 45.88,
  height: 45.88,
  x: 336.63,
  y: 179.89,
  className: "preferred-browser-off_svg__cls-15",
  rx: 22.94
})));

function SvgPreferredBrowserOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 558.98 584"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _ref2));
}

export default SvgPreferredBrowserOff;